module.exports = __webpack_public_path__ + "f66ff0953ed0e1689c992b623ff3c42f.png";